import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const SpinnerBackgroundCircle = styled.circle`
  stroke: #ddd;
`;

const StyledSpinner = styled.svg`
  animation: spinnerRotateAnimation 2s linear infinite;
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;

  & .spinnerRotateCircle {
    stroke: #2c82be;
    stroke-linecap: round;
    animation: spinnerDashAnimation 1.5s ease-in-out infinite;
  }

  @keyframes spinnerRotateAnimation {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes spinnerDashAnimation {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

const Spinner = ({ size }) => (
  <StyledSpinner height={size} width={size} viewBox="0 0 50 50">
    <SpinnerBackgroundCircle cx="25" cy="25" r="20" fill="none" strokeWidth="4" />
    <circle className="spinnerRotateCircle" cx="25" cy="25" r="20" fill="none" strokeWidth="4" />
  </StyledSpinner>
);

Spinner.propTypes = {
  size: PropTypes.number.isRequired
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js